/**
 * Initializes and manages the locations map section.
 */
window.addEventListener('load', function () {
  const mapEl  = document.getElementById('locationsMap');
  const listEl = document.getElementById('locationsList');
  if (!mapEl || typeof L === 'undefined') return;

  // 1) Prefer inline JSON; 2) fallback to DOM attributes
  let data = (window.LOCATIONS_DATA || []).filter(Boolean);
  if (!data.length && listEl) {
    data = Array.from(listEl.querySelectorAll('.loc-jump')).map(btn => ({
      id: btn.dataset.id,
      titleHtml: (btn.querySelector('.loc-title')?.innerHTML || '').trim(),
      lat: parseFloat(btn.dataset.lat),
      lng: parseFloat(btn.dataset.lng),
    })).filter(d => Number.isFinite(d.lat) && Number.isFinite(d.lng));
  }

  if (!data.length) {
    // Nothing to render; bail silently
    return;
  }

  // Fix any known typos (e.g., Manchester long)
  for (const d of data) {
    if (d.id === 'manchester' && Math.abs(d.lng + 2.2453) > 0.0001) {
      d.lng = -2.2453;
    }
  }

  // Brand palette (works well on OSM)
  const COLOR_FILL   = '#1EC0DA';
  const COLOR_STROKE = '#004053';
  const COLOR_HOVER  = '#08889d';
  const SMALL_VIEW_WIDTH = 1024;
  const isSmallViewport = window.innerWidth <= SMALL_VIEW_WIDTH;
  const markerIconSize = isSmallViewport ? 24 : 30;

  const map = L.map(mapEl, { scrollWheelZoom: false });
  const cartoApiKey = window.CARTO_MAP_CONFIG?.apiKey || '';

 L.tileLayer(
  'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=' + encodeURIComponent(cartoApiKey),
  {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attribution/">CARTO</a>',
    subdomains: 'abcd',
    maxZoom: 20,
  }
).addTo(map);

// L.tileLayer(
//   'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
//   {
//     attribution:
//       '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
//     subdomains: 'abcd',
//     maxZoom: 20,
//   }
// ).addTo(map);

  const markerStyle = {
    radius: 10,
    weight: 2,
    color: COLOR_STROKE,
    fillColor: COLOR_FILL,
    fillOpacity: 0.95,
  };

  const group = L.featureGroup().addTo(map);
  const markers = new Map();
  let initialView = { center: null, zoom: null }; // <- store the FINAL (focused) initial view
  let pinnedMarker = null;
  const isHoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setMarkerHighlight(marker, isActive) {
    const img = marker?._icon?.querySelector('.marker-logo');
    if (!img) return;

    img.style.filter = isActive
      ? 'drop-shadow(2px 2px 4px rgba(0,0,0,0.35)) brightness(1.2)'
      : 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))';
  }

  function pinMarker(marker) {
    if (pinnedMarker && pinnedMarker !== marker) {
      setMarkerHighlight(pinnedMarker, false);
      pinnedMarker.closePopup();
    }

    pinnedMarker = marker;
    if (pinnedMarker) {
      setMarkerHighlight(pinnedMarker, true);
      pinnedMarker.openPopup();
    }
  }

  function clearPinnedMarker() {
    if (!pinnedMarker) return;

    setMarkerHighlight(pinnedMarker, false);
    pinnedMarker.closePopup();
    pinnedMarker = null;
  }

  function focusMarker(marker) {
    if (!marker) return;

    const targetLatLng = marker.getLatLng();
    const targetZoom = Math.max(map.getZoom(), 8);

    pinMarker(marker);
    map.flyTo(targetLatLng, targetZoom, {
      animate: true,
      duration: 0.6,
      easeLinearity: 0.25
    });
  }


  data.forEach(loc => {
    const popupHtml = `
      <div class="popup">
        <div class="popup__title">${loc.titleHtml || ''}</div>
      </div>
    `;

     // Create custom SVG icon
  const svgIcon = L.divIcon({
    html: `
      <div class="custom-marker">
        <img src="/wp-content/themes/amblunz/dist/svgs/logo-svg-icon-ambulnz.svg" 
             alt="Location marker" 
             class="marker-logo">
      </div>
    `,
    className: 'custom-div-icon', // Remove default leaflet styling
    iconSize: [markerIconSize, markerIconSize],
    iconAnchor: [markerIconSize / 2, markerIconSize / 2], // Center the icon
    popupAnchor: [0, isSmallViewport ? -16 : -18] // Position popup above the icon
  });

  const m = L.marker([loc.lat, loc.lng], { icon: svgIcon }).bindPopup(popupHtml);
  
    // Desktop (hover devices): show popup + style on hover
    if (isHoverCapable) {
      m.on('mouseover', function() {
        if (pinnedMarker === this) return;

        this.openPopup();
        setMarkerHighlight(this, true);
      });
      m.on('mouseout', function(e) {
        if (pinnedMarker === this) return;

        // close only if not moving into the popup container
        const related = e.originalEvent?.relatedTarget;
        if (!related || !related.closest('.leaflet-popup')) {
          this.closePopup();
        }
        setMarkerHighlight(this, false);
      });
      m.on('click', function(e) {
        L.DomEvent.stop(e);
        focusMarker(this);
      });
    } else {
      // Mobile: keep click behavior (Leaflet default opens popup). Just add active style toggle.
      m.on('click', function() {
        setMarkerHighlight(this, true);
      });
      m.on('popupclose', function() {
        setMarkerHighlight(this, false);
      });
    }
    m.addTo(group);
    markers.set(loc.id, m);
  });

  map.on('click', () => {
    if (!isHoverCapable || window.innerWidth <= 1024) return;

    clearPinnedMarker();
  });

  // Fit to markers (or UK default)
    // Fit to markers (or fallback) and store initial view
 // let initial = {};
  try {
    const b = group.getBounds();

    if (b.isValid()) {
      // Mobile: nudge the initial fit in slightly without affecting desktop.
      const padAmount = isSmallViewport ? 0.20 : 0.20;
      map.fitBounds(b.pad(padAmount));

      setTimeout(() => {
        const currentZoom = map.getZoom();
        // Leave mobile at the fitted zoom; desktop still gets a +1 step.
        const targetZoom = isSmallViewport
          ? currentZoom
          : Math.min(currentZoom + 1, 12);
        map.setZoom(targetZoom);
        initialView.center = map.getCenter();
        initialView.zoom = targetZoom;
      }, 150);
    } else {
      // Fallback center (UK-ish).
      const baseZoom = isSmallViewport ? 5 : 6;
      const focusedZoom = isSmallViewport ? 6 : 7;
      map.setView([52.9, -1.5], baseZoom);
      setTimeout(() => {
        map.setZoom(focusedZoom);
        initialView.center = map.getCenter();
        initialView.zoom = focusedZoom;
      }, 150);
    }
  } catch {
    map.setView([52.9, -1.5], isSmallViewport ? 5 : 6);
    setTimeout(() => {
      map.setZoom(isSmallViewport ? 6 : 7);
      initialView.center = map.getCenter();
      initialView.zoom = map.getZoom();
    }, 150);
  }

  if (!initialView.center) {
    // fallback (in case user hovers super fast)
    initialView.center = map.getCenter();
    initialView.zoom = map.getZoom();
  }


  // Make sure the map paints if inside a freshly shown layout
  setTimeout(() => map.invalidateSize(), 60);
  window.addEventListener('resize', () => map.invalidateSize());

  // List → map interaction
if (listEl) {
    function setActive(btn) {
      listEl.querySelectorAll('.loc-jump.active').forEach(b => b.classList.remove('active'));
      if (btn) btn.classList.add('active');
    }

    function scrollMapIntoView() {
      // Allow scroll-to-map when viewport width <= 1024 (even on desktop with a mouse)
      if (window.innerWidth <= SMALL_VIEW_WIDTH) {
        const header = document.querySelector('.site-header, header, .main-header');
const headerHeight = header ? header.getBoundingClientRect().height : 0;
const extraOffset = 120; // extra space above the map
const y = mapEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - extraOffset;
window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    if (isHoverCapable && window.innerWidth > SMALL_VIEW_WIDTH) {
      // Large hover-capable (desktop normal) → hover behavior only
      listEl.addEventListener('mouseover', (e) => {
        const btn = e.target.closest('.loc-jump');
        if (!btn) return;
        const marker = markers.get(btn.dataset.id);
        focusMarker(marker);
        setActive(btn);
      });

      listEl.addEventListener('mouseleave', () => {
        listEl.querySelectorAll('.loc-jump.active').forEach(b => b.classList.remove('active'));
        clearPinnedMarker();
        map.closePopup();
        if (initialView.center) {
          map.flyTo(initialView.center, initialView.zoom, {
            animate: true,
            duration: 0.5,
            easeLinearity: 0.25
          });
        }
      });
    } else {
      // Mobile OR reduced-width viewport (≤1024) even if hover-capable → click + scroll
      listEl.addEventListener('click', (e) => {
        const btn = e.target.closest('.loc-jump');
        if (!btn) return;
        const marker = markers.get(btn.dataset.id);
        focusMarker(marker);
        setActive(btn);
        scrollMapIntoView();
      });
    }

    // If user resizes across the threshold, we still want clicks to scroll when small
    // window.addEventListener('resize', () => {
    //   // No need to rebind listeners; scrollMapIntoView checks size each time
    // });
  }
});

// Example: when a tab becomes visible
document.addEventListener('myTabShown', () => {
  map.invalidateSize(); // after it's visible
});